(function () {
  if (window.__IG_ID8_LOADED__) return;
  window.__IG_ID8_LOADED__ = true;

  var CLASS_NAME = "ig-id8-a";
  var swipers = [];
  var mounted = false;
  var classObs = null;
  var wasActive = false;

  function isHome() {
    var path = window.location.pathname.replace(/\/+$/, "") || "/";
    return (
      path === "/" ||
      document.body.classList.contains("template-index") ||
      document.documentElement.classList.contains("template-index")
    );
  }

  function isActive() {
    return document.documentElement.classList.contains(CLASS_NAME);
  }

  function destroySwipers() {
    for (var i = 0; i < swipers.length; i++) {
      try {
        swipers[i].destroy(true, true);
      } catch (e) {}
    }
    swipers = [];
  }

  function initSwiper(root) {
    if (!window.Swiper) return;
    destroySwipers();
    var panels = root.querySelectorAll("[data-ig-id8-panel]");
    for (var i = 0; i < panels.length; i++) {
      var panel = panels[i];
      var el = panel.querySelector("[data-ig-id8-slider]");
      var bar = panel.querySelector(".ig-id8__scrollbar");
      if (!el || el.swiper) continue;
      var instance = new Swiper(el, {
        loop: false,
        slidesPerView: "auto",
        grabCursor: true,
        scrollbar: bar
          ? {
              el: bar,
              draggable: true
            }
          : undefined,
        mousewheel: {
          forceToAxis: true,
          sensitivity: 1,
          releaseOnEdges: true
        },
        on: {
          scrollbarDragStart: function () {
            document.body.classList.add("dragging");
          },
          scrollbarDragEnd: function () {
            document.body.classList.remove("dragging");
          }
        }
      });
      swipers.push(instance);
      if (panel.hidden) {
        try {
          instance.disable();
        } catch (e) {}
      }
    }
  }

  function activateTab(root, tab) {
    if (!tab) return;
    var handle = tab.getAttribute("data-handle");
    var label = tab.getAttribute("data-label") || "";
    var url = tab.getAttribute("data-url") || "#";
    var title = root.querySelector("[data-ig-id8-title]");
    var cta = root.querySelector("[data-ig-id8-cta]");
    var tabs = root.querySelectorAll("[data-ig-id8-tab]");
    var panels = root.querySelectorAll("[data-ig-id8-panel]");

    if (title) title.textContent = label;
    if (cta) cta.setAttribute("href", url);

    for (var i = 0; i < tabs.length; i++) {
      var active = tabs[i] === tab;
      tabs[i].classList.toggle("is-active", active);
      tabs[i].setAttribute("aria-selected", active ? "true" : "false");
    }

    for (var p = 0; p < panels.length; p++) {
      var panel = panels[p];
      var match = panel.getAttribute("data-handle") === handle;
      panel.classList.toggle("is-active", match);
      if (match) panel.removeAttribute("hidden");
      else panel.setAttribute("hidden", "");
    }

    for (var s = 0; s < swipers.length; s++) {
      try {
        var sliderEl = swipers[s].el;
        var parentPanel = sliderEl && sliderEl.closest("[data-ig-id8-panel]");
        if (!parentPanel) continue;
        if (parentPanel.getAttribute("data-handle") === handle) {
          swipers[s].enable();
          swipers[s].update();
        } else {
          swipers[s].disable();
        }
      } catch (e) {}
    }
  }

  function openQuickView(quickBtn) {
    var apple = quickBtn.getAttribute("data-apple");
    var url = quickBtn.getAttribute("data-url");
    var modal = quickBtn.getAttribute("data-modal");
    if (!url || !modal) return;

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (response) {
        var html = new DOMParser().parseFromString(response, "text/html");
        var source = html.getElementById("section-quick-buy");
        if (!source) return;
        if (apple === "false") {
          var appleBtn = source.querySelector(".appple-pay-btn");
          if (appleBtn) appleBtn.remove();
        }
        document.body.classList.add("open-quick-buy");
        var modalEl = document.getElementById(modal);
        if (!modalEl) return;
        var popup = modalEl.getElementsByClassName("quick-buy-popup")[0];
        if (!popup) return;
        popup.innerHTML = source.innerHTML;
        if (typeof addToCart === "function") addToCart();
        if (typeof quickviewslider === "function") {
          setTimeout(function () {
            quickviewslider();
          }, 100);
        }
      })
      .catch(function (e) {
        if (window.console && console.error) console.error(e);
      });
  }

  function bindRootInteractions(root) {
    if (root.dataset.igId8Bound === "1") return;
    root.dataset.igId8Bound = "1";

    root.addEventListener("click", function (event) {
      var tab = event.target.closest("[data-ig-id8-tab]");
      if (tab && root.contains(tab)) {
        event.preventDefault();
        activateTab(root, tab);
        return;
      }

      var quickBtn = event.target.closest(".quick_view_button");
      if (quickBtn && root.contains(quickBtn)) {
        event.preventDefault();
        event.stopPropagation();
        openQuickView(quickBtn);
        return;
      }

      var quickAdd = event.target.closest(".quick_add");
      if (quickAdd && root.contains(quickAdd)) {
        event.preventDefault();
        event.stopPropagation();
        document.querySelectorAll(".grid-variant-outer").forEach(function (el) {
          el.classList.remove("active-grid-size");
        });
        var targetGrid = quickAdd
          .closest(".snippet-product-grid")
          ?.querySelector(".grid-variant-outer");
        if (targetGrid) targetGrid.classList.add("active-grid-size");
        return;
      }

      var gridApple = event.target.closest(".grid-apple-checkout");
      if (gridApple && root.contains(gridApple)) {
        event.preventDefault();
        event.stopPropagation();
        var grid = gridApple.closest(".snippet-product-grid");
        if (!grid) return;
        if (screen.width > 991) {
          var addBtn = grid.querySelector(".quick_add");
          if (addBtn) addBtn.click();
        } else {
          var viewBtn = grid.querySelector(".quick_view_button");
          if (viewBtn) openQuickView(viewBtn);
        }
      }
    });
  }

  function mount() {
    if (!isHome() || !isActive() || mounted) return;
    var root = document.querySelector("[data-ig-id8]");
    if (!root) return;

    initSwiper(root);
    bindRootInteractions(root);
    if (typeof productrow === "function") productrow();

    var firstTab =
      root.querySelector("[data-ig-id8-tab].is-active") ||
      root.querySelector("[data-ig-id8-tab]");
    activateTab(root, firstTab);
    mounted = true;
  }

  function boot() {
    if (!isHome()) return;
    wasActive = isActive();
    mount();

    classObs = new MutationObserver(function () {
      var active = isActive();
      if (active && !wasActive) {
        mounted = false;
        mount();
      }
      wasActive = active;
    });
    classObs.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"]
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
